import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=4e04747d&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"
import style0 from "./Companies.vue?vue&type=style&index=0&id=4e04747d&prod&lang=scss&scoped=true"
import style1 from "./Companies.vue?vue&type=style&index=1&id=4e04747d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e04747d",
  null
  
)

export default component.exports